module.exports = __webpack_public_path__ + "img/smartphone.a079e0ea.svg";